export const PRICING_REPORT_GALLERY_THUMBNAIL_TRANSFORM_KEY = "full-image-thumbnail";
export const PRICING_REPORT_AGGREGATE_CARD_IMAGE_TRANSFORM_KEY = "brand-portal-image-card-square";

/**
 * Appends a Directus asset transform key when the URL does not already include one.
 *
 * @param {string | null | undefined} imageUrl
 * @param {string} [transformKey]
 */
export function withDirectusAssetTransformKey(
  imageUrl,
  transformKey = PRICING_REPORT_GALLERY_THUMBNAIL_TRANSFORM_KEY
) {
  if (!imageUrl || typeof imageUrl !== "string") return "";
  if (imageUrl.includes("key=")) return imageUrl;

  const separator = imageUrl.includes("?") ? "&" : "?";
  return `${imageUrl}${separator}key=${transformKey}`;
}
